export default function Services() {
  const services = [
    {
      icon: 'ri-brain-line',
      title: 'AIコンサルティング',
      description: '業務分析から導入、定着まで一貫サポート。ChatGPT、Claude、Geminiなど最適なツールを提案し、実務で使える形に落とし込みます。',
      features: ['業務フロー設計', 'プロンプト設計', '社内研修・伴走支援'],
      image: 'https://public.readdy.ai/ai/img_res/63f8c240d7ae528a041ae797856ac123.jpg'
    },
    {
      icon: 'ri-quill-pen-line',
      title: 'AIライティング',
      description: 'AIを活用した高品質なコンテンツ制作。SEO記事、LP、メルマガ、SNS投稿まで、目的に応じた文章を効率的に作成します。',
      features: ['SEO記事作成', 'LP・セールスライティング', 'メルマガ・SNS投稿'],
      image: 'https://readdy.ai/api/search-image?query=japanese-asian-professional-woman-with-long-hair-working-on-laptop-computer-writing-content-modern-bright-minimalist-office-workspace-natural-daylight-focused-expression-creative-writing-atmosphere-clean-simple-background&width=600&height=400&seq=ai-writing-jp-service-longhair-002&orientation=landscape'
    },
    {
      icon: 'ri-share-line',
      title: 'SNS・コンテンツ支援',
      description: '発信力を高める戦略設計と運用サポート。ターゲット分析、投稿計画、エンゲージメント向上まで総合的に支援します。',
      features: ['SNS戦略設計', '投稿計画・運用代行', 'エンゲージメント分析'],
      image: 'https://readdy.ai/api/search-image?query=japanese-asian-professional-business-people-team-meeting-discussing-social-media-content-strategy-with-smartphone-tablet-devices-showing-SNS-apps-modern-bright-office-collaborative-workspace-natural-daylight-engaged-discussion-atmosphere&width=600&height=400&seq=sns-support-jp-service-003&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="mb-12 sm:mb-16 text-center animate-fade-in-up">
          <span className="inline-block bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold px-5 py-2 rounded-full mb-4">
            SERVICES
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-purple-900 tracking-tight mb-4 sm:mb-6">
            提供サービス
          </h2>
          <p className="text-base sm:text-lg font-medium text-purple-800 max-w-2xl mx-auto px-4">
            AIの力を最大限に引き出し、<br className="hidden sm:block" />
            ビジネスの成長を加速させます
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 animate-fade-in-up"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/60 to-transparent"></div>
                <div className="absolute top-4 left-4 w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-3xl text-purple-600`}></i>
                </div>
              </div>
              
              <div className="p-6 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-semibold text-purple-900 mb-3 sm:mb-4">
                  {service.title}
                </h3>
                <p className="text-base font-medium text-purple-800 mb-4 sm:mb-6 leading-relaxed">
                  {service.description}
                </p>
                <ul className="space-y-2 sm:space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2 sm:gap-3">
                      <i className="ri-check-line text-lg sm:text-xl text-purple-500 flex-shrink-0 mt-0.5"></i>
                      <span className="text-sm sm:text-base font-medium text-purple-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center animate-fade-in-up" style={{ animationDelay: '600ms' }}>
          <a
            href="#contact"
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-8 py-4 rounded-full font-semibold text-base hover:from-purple-600 hover:to-pink-600 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-xl"></i>
            サービスについて相談する
          </a>
        </div>
      </div>
    </section>
  );
}